import { IDeleteRequisicaoCompraProdutoServicoUseCase } from "../../../presentation/useCases/delete/delete_requisicao_compra_produto_servico_use_case";
import { IComprasRepository } from "../../repositories/compras_repositories";

/**
 * DeleteRequisicaoCompraProdutoServicoUseCase
 */

export class DeleteRequisicaoCompraProdutoServicoUseCase implements IDeleteRequisicaoCompraProdutoServicoUseCase {
  constructor(private readonly repository: IComprasRepository) { }

  async deleteRequisicaoCompraProdutoServico(
    idRequisicaoProdutoServico: number,
  ): Promise<void> {
    await this.repository.deleteRequisicaoCompraProdutoServico(
      idRequisicaoProdutoServico,
    );
  }
}
